import React, { useRef } from "react";
import { images } from "../../assets/images";
import { sidebarOptions } from "./menuOptions";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useClickAway } from "react-use";
import { icons } from "../../assets/icons";
import ProfilePic from "../../assets/images/profile1.png";
import { motion } from "framer-motion";

const ProfileSidebar = () => {
  const location = useLocation();
  const { user } = useAuth();
  const navigate = useNavigate();
  const dashboardRef = useRef();
  const { profileDashboardVisible, setProfileDashboardVisible, logout } =
    useAuth();

  useClickAway(dashboardRef, () => {
    setProfileDashboardVisible(false);
  });

  const {
    user: { userLabel },
  } = useAuth();

  if (!profileDashboardVisible) {
    return null;
  }

  return (
    <div className="profile-sidebar-container">
      <div
        className="profile-sidebar-wrapper w-80"
        ref={dashboardRef}
        // animate={{ width: profileDashboardVisible ? "82%" : "0%" }}
        style={{
          width: '82%'
        }}
        // transition={{ duration: 0.2 }}
      >
        {/* <img
          src={images.mainLogo}
          className="dashboard-logo"
          alt="keventer's logo"
        /> */}
        <div className="flex items-start justify-between border-b w-full" style={{ height: "63px" }}>
          <div
            className="flex justify-between gap-x-[1.2rem] cursor-pointer py-2 select-none ml-10 mb-4 overflow-hidden"
            // style={{maxWidth: '60%'}}
            // onClick={() => setDropDownOpen(!dropDownOpen)}
          >
            <img
              // src="https://picsum.photos/200/300"
              src={ProfilePic}
              className="user-image"
              alt="user"
            />

            <div className="cursor-pointer">
              <div className="flex items-center">
                <motion.div animate={{opacity: 1}} initial={{ opacity: 0}} transition={{duration: 1}} className="font-size-medium font-family-medium text-[var(--blackColor)] mr-10">
                  {user?.name || ""}
                </motion.div>
              </div>
              <motion.div animate={{opacity: 1}} initial={{ opacity: 0}} transition={{duration: 1}} className="font-size-small text-[var(--lightGray)] leading-[1.4rem]">
                {user?.userLabel || ""}
              </motion.div>
            </div>
          </div>
          <div
            className="text-[var(--text-red)] cursor-pointer text-3xl mr-6 mt-2"
            onClick={() => setProfileDashboardVisible(false)}
          >
            [x]
          </div>
        </div>
        <div className="profile-sidebar-options">
          {sidebarOptions.map((item, index) => {
            const isActive =
              item.link === "/"
                ? location.pathname === item.link
                : location.pathname.includes(item.link);

            if (!item.showTo.includes(userLabel)) {
              return null;
            }

            if (!item.link) {
              return (
                <div
                  className={`profile-sidebar-option ${
                    isActive ? "profile-sidebar-option-active" : ""
                  }`}
                  onClick={() => {
                    setProfileDashboardVisible(false);
                    logout();
                  }}
                >
                  <div className="profile-sidebar-option-icon-wrapper">
                    <img src={item.icon} alt="profile-sidebar option icon" />
                  </div>
                  <div
                    className={`profile-sidebar-option-title font-size-small ${
                      isActive ? "font-family-medium" : ""
                    }`}
                  >
                    {item.title}
                  </div>
                </div>
              );
            }

            return (
              <Link
                to={item.link}
                key={"option-" + index}
                onClick={() => {
                  setProfileDashboardVisible(false);
                }}
              >
                <div
                  className={`profile-sidebar-option ${
                    isActive ? "profile-sidebar-option-active" : ""
                  }`}
                >
                  <div className="profile-sidebar-option-icon-wrapper">
                    <img src={item.icon} alt="profile-sidebar option icon" />
                  </div>
                  <div
                    className={`profile-sidebar-option-title font-size-small ${
                      isActive ? "font-family-medium" : ""
                    }`}
                  >
                    {item.title}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProfileSidebar;
